<app-tools-page-tabs></app-tools-page-tabs>

<nav class="breadcrumb-sm" aria-label="Breadcrumb">
    <div class="container">
        <ol class="cd-breadcrumb">
			<li><a [routerLink]="['/']">Home</a>
                <span aria-hidden="true" class="breadcrumb-separator">&raquo;</span>
            </li>
			<li class="current" aria-current="page"><em>Paraphrasing Tool</em></li>
		</ol>
    </div>
</nav>

<section class="banner-section" style="overflow: inherit;" #target>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="banner-title">
                    <h1><span>Free AI Paraphrasing Tool</span></h1>
                    <h2>Trinka’s AI-powered Paraphrasing Tool helps you instantly paraphrase, edit, and rephrase your sentences with ease.</h2>
                    <h2 class="d-sm-none d-block">Get coherent rephrases while preserving the original meaning with Trinka's Paraphrasing Tool.</h2>
                    
                    <div class="btn-group justify-content-center mt-30">
                        <a [href]="trinkaCloudUrl + '/guest-mode?redirect=paraphraser&rg_GB'" class="filled-btn" target="_blank" rel="noopener noreferrer">Try Our Paraphrasing Tool — No Signup Required</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-none">
            <div class="col-lg-12">
                <div class="card paraphraser-card">
                    <div class="card-header">
                        <h3 class="d-none d-md-block">Paraphrase Your Text</h3>
                        <div class="degreeChange">
                            <ul>
                                <li>
                                    <div class="slidecontainer">
                                        <span>Degree of Change</span>
                                        <div class="" style="display: flex;align-items: center;">
                                            <i class="lowTextSection" style="left: -26px;right: auto;">Low</i>
                                            <input id="myRange" class="slider" type="range" min="1" max="2" step="0.5" [value]="paraphraseTemperature" [(ngModel)]="paraphraseTemperature" [ngModelOptions]={standalone:true} (change)="updateParaphraseTemperature($event)" aria-label="degree of change">
                                            <i class="highTextSection" style="right: -26px;left: auto;">High</i>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="toggleDiffOption">
                                        <i>Show Revisions</i>
                                        <label class="switch" aria-label="show revision">
                                          <input id="toggleDiffOptionCheckbox" type="checkbox" [(ngModel)]="toggleDiffOptionModel" [ngModelOptions]={standalone:true} [checked]="toggleDiffOptionModel" (change)="onToggleDiffOption()">
                                          <span class="slider round"></span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="feedback" (click)="openFeedbackModal()">
                                        <svg class="feedbackIcons" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.99996 19.0082C9.42496 19.0082 8.88329 18.7165 8.49996 18.2082L7.24996 16.5415C7.22496 16.5082 7.12496 16.4665 7.08329 16.4582H6.66663C3.19163 16.4582 1.04163 15.5165 1.04163 10.8332V6.6665C1.04163 2.98317 2.98329 1.0415 6.66663 1.0415H13.3333C17.0166 1.0415 18.9583 2.98317 18.9583 6.6665V10.8332C18.9583 14.5165 17.0166 16.4582 13.3333 16.4582H12.9166C12.85 16.4582 12.7916 16.4915 12.75 16.5415L11.5 18.2082C11.1166 18.7165 10.575 19.0082 9.99996 19.0082ZM6.66663 2.2915C3.68329 2.2915 2.29163 3.68317 2.29163 6.6665V10.8332C2.29163 14.5998 3.58329 15.2082 6.66663 15.2082H7.08329C7.50829 15.2082 7.99163 15.4498 8.24996 15.7915L9.49996 17.4582C9.79163 17.8415 10.2083 17.8415 10.5 17.4582L11.75 15.7915C12.025 15.4248 12.4583 15.2082 12.9166 15.2082H13.3333C16.3166 15.2082 17.7083 13.8165 17.7083 10.8332V6.6665C17.7083 3.68317 16.3166 2.2915 13.3333 2.2915H6.66663Z" fill="#7A28A0"/>
                                            <path d="M14.1667 7.2915H5.83337C5.49171 7.2915 5.20837 7.00817 5.20837 6.6665C5.20837 6.32484 5.49171 6.0415 5.83337 6.0415H14.1667C14.5084 6.0415 14.7917 6.32484 14.7917 6.6665C14.7917 7.00817 14.5084 7.2915 14.1667 7.2915Z" fill="#7A28A0"/>
                                            <path d="M10.8334 11.4585H5.83337C5.49171 11.4585 5.20837 11.1752 5.20837 10.8335C5.20837 10.4918 5.49171 10.2085 5.83337 10.2085H10.8334C11.175 10.2085 11.4584 10.4918 11.4584 10.8335C11.4584 11.1752 11.175 11.4585 10.8334 11.4585Z" fill="#7A28A0"/>
                                        </svg>
                                        <svg class="feedbackIconsHover" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.1667 1.66669H5.83334C3.53334 1.66669 1.66667 3.52502 1.66667 5.81669V10.8V11.6334C1.66667 13.925 3.53334 15.7834 5.83334 15.7834H7.08334C7.30834 15.7834 7.60834 15.9334 7.75001 16.1167L9.00001 17.775C9.55001 18.5084 10.45 18.5084 11 17.775L12.25 16.1167C12.4083 15.9084 12.6583 15.7834 12.9167 15.7834H14.1667C16.4667 15.7834 18.3333 13.925 18.3333 11.6334V5.81669C18.3333 3.52502 16.4667 1.66669 14.1667 1.66669ZM10.8333 11.4584H5.83334C5.49167 11.4584 5.20834 11.175 5.20834 10.8334C5.20834 10.4917 5.49167 10.2084 5.83334 10.2084H10.8333C11.175 10.2084 11.4583 10.4917 11.4583 10.8334C11.4583 11.175 11.175 11.4584 10.8333 11.4584ZM14.1667 7.29169H5.83334C5.49167 7.29169 5.20834 7.00835 5.20834 6.66669C5.20834 6.32502 5.49167 6.04169 5.83334 6.04169H14.1667C14.5083 6.04169 14.7917 6.32502 14.7917 6.66669C14.7917 7.00835 14.5083 7.29169 14.1667 7.29169Z" fill="#7A28A0"/>
                                        </svg>
                                        <b>Feedback</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-body" style="min-height: 360px;">
                        <div class="left-side">
                            <div class="form-group" style="height: calc(100% - 88px);">

                                <div class="editor-wrapper" style="position: relative; height: 100%; padding: 24px 40px 0px 24px;">
                                  <span *ngIf="wordCounts.input" class="pp-icon-times" (click)="clearEditors();" style="position: absolute; right: 10px; top: 15px; cursor: pointer;"></span>
                                  <div #inputEditor contenteditable="true" spellcheck="false" id="inputEditor" class="editor" style="height: 100%; outline: 0px solid transparent; overflow: hidden; padding-bottom: 30px;" (input)="onInputEditorChange($event)" placeholder="Type or paste your text to paraphrase... "
                                    spellcheck="false"
                                    autocomplete="off"
                                    autocorrect="off"
                                    autocapitalize="off"
                                    data-gramm="false"
                                    data-gramm_editor="false"
                                    data-enable-grammarly="false">
                                    </div>
                                </div>

                            </div>

                            <div class="card-footer">
                                <div  class="counter">
                                    <span class="count" [ngClass]="wordCounts.input >= 500 ? 'red': ''">{{ wordCounts.input }}/500 words</span>
                                </div>
                                <div class="button-wrap">
                                    <button type="button" (click)="paraphrase()" [disabled]="loader">
                                        <span [style.display]="loader ? 'none' : 'block'">Paraphrase</span>
                                        <div class="loadingContainer" [style.display]="loader ? 'block' : 'none'">
                                            <div class="ball1"></div>
                                            <div class="ball2"></div>
                                            <div class="ball3"></div>
                                            <div class="ball4"></div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right-side"> <!-- blur -->
                            <div class="form-group" style="height: calc(100% - 88px);">

                                <div class="editor-wrapper" style="height: 100%; padding: 24px 40px 0px 24px; position: relative;">
                                  <div #popoverOverlay id="popoverOverlay" style="top: 24px; left: 24px; right: 24px; bottom: 0;">
                                    <div style="position: relative; width: 100%; height: 100%;">
                                      <div #popover id="popover">
                                        <div class="popover-content">
                                          <div>
                                            <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'like', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-like"></span>
                                                <span class="pp-icon-like pp-icon-like-hover"></span>
                                            </span>
                                          </div>
                                          <div>
                                            <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'dislike', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-dislike"></span>
                                                <span class="pp-icon-dislike pp-icon-dislike-hover"></span>
                                            </span>
                                          </div>
                                          <div>
                                            <span class="textCopiedSection" (click)="popoverOptionSelected($event, 'copy', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-copy"></span>
                                                <span class="pp-icon-copy pp-icon-copy-hover"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div #alternativesPopover id="alternativesPopover">
                                        <div class="alternativesPopover-content">
                                          <div class="heading">
                                            <span>Alternatives</span>
                                            <span class="closePopoverBtn" (click)="closePopover()" style="cursor: pointer;">
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_330_14955)">
                                                    <path d="M17.4082 6.66472C17.7614 6.31148 17.7614 5.73877 17.4082 5.38553C17.0549 5.0323 16.4822 5.0323 16.129 5.38553L11.3414 10.1731L6.55388 5.38553C6.20064 5.0323 5.62793 5.0323 5.27469 5.38553C4.92146 5.73877 4.92146 6.31148 5.27469 6.66472L10.0622 11.4523L5.27469 16.2398C4.92146 16.593 4.92146 17.1658 5.27469 17.519C5.62793 17.8722 6.20064 17.8722 6.55388 17.519L11.3414 12.7315L16.129 17.519C16.4822 17.8722 17.0549 17.8722 17.4082 17.519C17.7614 17.1658 17.7614 16.593 17.4082 16.2398L12.6206 11.4523L17.4082 6.66472Z" fill="#414E62"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_330_14955">
                                                    <rect width="21.7085" height="21.7085" fill="white" transform="translate(0.487305 0.5979)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                            </span>
                                          </div>
                                          <div class="body">
                                            <ul *ngIf="currentSelectedSentenceState.alternatives">
                                              <ng-container *ngFor="let alternative of currentSelectedSentenceState.alternatives.output_sentence; let i = index;">
                                                <li *ngIf="currentSelectedSentenceState.index != i" (click)="switchToTheAlternative(alternative, i)">
                                                  <sentence [innerHTML]="alternative.suggestion_diff" *ngIf="toggleDiffOptionModel; else nonDiff"></sentence>
                                                  <ng-template #nonDiff>
                                                    <sentence>{{alternative.suggestion}}</sentence>
                                                  </ng-template>
                                                  <span class="likeAndDislikeButtons">
                                                    <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'like', currentSelectedSentenceState.alternatives.original_sentence, alternative.suggestion)">
                                                        <span class="pp-icon-like"></span>
                                                        <span class="pp-icon-like pp-icon-like-hover"></span>
                                                    </span>
                                                    <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'dislike', currentSelectedSentenceState.alternatives.original_sentence, alternative.suggestion)">
                                                        <span class="pp-icon-dislike"></span>
                                                        <span class="pp-icon-dislike pp-icon-dislike-hover"></span>
                                                    </span>
                                                  </span>
                                                </li>
                                              </ng-container>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div #outputEditor contenteditable="false" spellcheck="false" id="outputEditor" class="editor" style="outline: 0px solid transparent; overflow: hidden; padding-bottom: 30px;"></div>

                                  <div class="limit-exhausted-banner" *ngIf="wordCounts.output > 1 && isLimitExhausted && !loader">
                                    <h3>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.4645 14.3459L13.248 4.95619C12.5471 3.69282 11.5771 3 10.5094 3C9.44161 3 8.47166 3.69282 7.77069 4.95619L2.55419 14.3459C1.89397 15.5441 1.82062 16.6933 2.35042 17.5981C2.88022 18.5028 3.92352 19 5.29285 19H15.7259C17.0952 19 18.1385 18.5028 18.6683 17.5981C19.1981 16.6933 19.1247 15.5359 18.4645 14.3459ZM9.89805 8.70555C9.89805 8.37137 10.1752 8.09424 10.5094 8.09424C10.8435 8.09424 11.1207 8.37137 11.1207 8.70555V12.7809C11.1207 13.1151 10.8435 13.3923 10.5094 13.3923C10.1752 13.3923 9.89805 13.1151 9.89805 12.7809V8.70555ZM11.0881 15.8049C11.0473 15.8375 11.0066 15.8701 10.9658 15.9027C10.9169 15.9353 10.868 15.9598 10.8191 15.9761C10.7702 16.0005 10.7213 16.0168 10.6642 16.025C10.6153 16.0331 10.5583 16.0413 10.5094 16.0413C10.4605 16.0413 10.4034 16.0331 10.3463 16.025C10.2974 16.0168 10.2485 16.0005 10.1996 15.9761C10.1507 15.9598 10.1018 15.9353 10.0529 15.9027C10.0122 15.8701 9.97141 15.8375 9.93065 15.8049C9.78394 15.65 9.69428 15.4381 9.69428 15.2262C9.69428 15.0143 9.78394 14.8023 9.93065 14.6475C9.97141 14.6149 10.0122 14.5823 10.0529 14.5497C10.1018 14.5171 10.1507 14.4926 10.1996 14.4763C10.2485 14.4519 10.2974 14.4356 10.3463 14.4274C10.4523 14.403 10.5664 14.403 10.6642 14.4274C10.7213 14.4356 10.7702 14.4519 10.8191 14.4763C10.868 14.4926 10.9169 14.5171 10.9658 14.5497C11.0066 14.5823 11.0473 14.6149 11.0881 14.6475C11.2348 14.8023 11.3244 15.0143 11.3244 15.2262C11.3244 15.4381 11.2348 15.65 11.0881 15.8049Z" fill="#FFBD4A"/>
                                        </svg>
                                        Word limit reached
                                    </h3>
                                    <p>You can paraphrase <strong>500 words</strong> at a time. For longer paragraphs, split the paragraph into smaller ones and then paraphrase. </p>
                                  </div>

                                </div>
                            </div>
                            <div class="card-footer">
                                <div  class="counter">
                                    <!-- <span class="count">{{ wordCounts.output }} words</span> -->
                                </div>
                                <div class="copy-text">
                                    <span [ngClass]="toggleDiffOptionModel ? 'disableCopyOption': ''" >
                                        <span class="disabledTooltip">Turn revisions off to copy</span>
                                        <span class="copyTooltip">Copy text</span>
                                        <img src="../../../assets/images/copy.svg" alt="copy" (click)="copyOutputEditorContent()" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <ul class="wordcrumbs">
                    <li>Changed Text</li>
                    <li>Paraphrased text</li>
                </ul>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2 d-lg-block d-none"></span>
    <span class="shape-3"></span>
</section>

<section class="section-pd bg-light-purple list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>What is Paraphrasing Tool? </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100 mb-0">A paraphrasing tool helps to rephrase the sentences in a clearer, and natural way without changing the original meaning. Whether you are editing essays, articles, emails, or any academic content, Trinka’s AI-powered paraphraser helps to improve the sentence flow, and create polished content in seconds.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd-xs trinka-banner">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter">
                    <span>
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 6V12" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16.24 16.24L12 12" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </span>
                    <p>Saves <br/>Time</p>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter">
                    <span>
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Interface / Slider_02"> <path id="Vector" d="M14 18H21M3 18H5M5 18C5 19.3807 6.11929 20.5 7.5 20.5C8.88071 20.5 10 19.3807 10 18C10 16.6193 8.88071 15.5 7.5 15.5C6.11929 15.5 5 16.6193 5 18ZM20 12H21M3 12H10M13 6H21M13 6C13 4.61929 11.8807 3.5 10.5 3.5C9.11929 3.5 8 4.61929 8 6C8 7.38071 9.11929 8.5 10.5 8.5C11.8807 8.5 13 7.38071 13 6ZM3 6H4M16.5 14.5C15.1193 14.5 14 13.3807 14 12C14 10.6193 15.1193 9.5 16.5 9.5C17.8807 9.5 19 10.6193 19 12C19 13.3807 17.8807 14.5 16.5 14.5Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>
                    </span>
                    <p>Adjust Degree of Change </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter pt-lg-0 pt-3">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 8.50003L4.5 0.5L8.5 8.50003M1.8333 5.83333H7.1667M7.1667 11.1666L8.5 12.5L11.1667 9.83333" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <p>Checks Revisions </p>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 col-sm-6 col-6">
                <div class="counter pt-lg-0 pt-3">
                    <span>
                        <svg width="40" height="40" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.707 12L6 3.293C5.8094 3.11142 5.55625 3.01014 5.293 3.01014C5.02975 3.01014 4.7766 3.11142 4.586 3.293L3.293 4.586C3.10553 4.77353 3.00021 5.02784 3.00021 5.293C3.00021 5.55816 3.10553 5.81247 3.293 6L11.9995 14.707C12.187 14.8945 12.4413 14.9998 12.7065 14.9998C12.9717 14.9998 13.226 14.8945 13.4135 14.707L14.707 13.414C14.8945 13.2265 14.9998 12.9722 14.9998 12.707C14.9998 12.4418 14.8945 12.1875 14.707 12ZM4 5.293L5.293 4L7.793 6.5L6.4995 7.7935L4 5.293ZM12.7065 14L7.2065 8.5005L8.5 7.207L14 12.707L12.7065 14ZM1 8L2 7L3 8L2 9L1 8ZM7 2L8 1L9 2L8 3L7 2ZM1 2L2 1L3 2L2 3L1 2Z" fill="#fff"/>
                        </svg> 
                    </span>
                    <p>Improve Readability</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h2>Why Choose Trinka Paraphrasing Tool?</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2" style="padding: 0;">
                        <p>Trinka’s paraphrasing tool is designed to enhance the fluency of your content without compromising on  vocabulary, tone, and style you are aiming for.</p>
                        <p>You can refine each sentence by choosing from a number of paraphrasing options. You can easily control how much of your text is reworded, so that every version fits  your writing needs.</p>
                        <p>Rewriting and grammar checks is simple with our free paraphrasing tool and <a [routerLink]="['/grammar-checker']" class="text-link">grammar checker</a>. Just click once, and get various tailored versions of your text.  
                        </p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="../../../assets/images/paraphrase.svg" alt="paraphrasing tool" class="img-fluid" />
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>


<section class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10">
                <div class="trinka-title text-center">
                    <h2>How Trinka’s Paraphrasing Tool Works?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row flex-row-reverse align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-content-2" style="padding: 0;">
                    <div class="useCard media media-steps">
                        <div class="media-left">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M4.61763 16.2666C4.1093 16.2666 3.6343 16.0916 3.29263 15.7666C2.8593 15.3583 2.65097 14.7416 2.72597 14.075L3.0343 11.375C3.09263 10.8666 3.40097 10.1916 3.7593 9.82496L10.601 2.58329C12.3093 0.774959 14.0926 0.72496 15.901 2.43329C17.7093 4.14163 17.7593 5.92496 16.051 7.73329L9.2093 14.975C8.8593 15.35 8.2093 15.7 7.70096 15.7833L5.01763 16.2416C4.87597 16.25 4.75097 16.2666 4.61763 16.2666ZM13.276 2.42496C12.6343 2.42496 12.076 2.82496 11.5093 3.42496L4.66763 10.675C4.50097 10.85 4.3093 11.2666 4.27597 11.5083L3.96763 14.2083C3.9343 14.4833 4.00097 14.7083 4.15097 14.85C4.30097 14.9916 4.52597 15.0416 4.80097 15L7.4843 14.5416C7.72597 14.5 8.12597 14.2833 8.29263 14.1083L15.1343 6.86663C16.1676 5.76663 16.5426 4.74996 15.0343 3.33329C14.3676 2.69163 13.7926 2.42496 13.276 2.42496Z" fill="#7A28A0"/>
                                    <path d="M14.4497 9.12504C14.433 9.12504 14.408 9.12504 14.3914 9.12504C11.7914 8.8667 9.69971 6.8917 9.29971 4.30837C9.24971 3.9667 9.48305 3.65004 9.82471 3.5917C10.1664 3.5417 10.483 3.77504 10.5414 4.1167C10.858 6.13337 12.4914 7.68337 14.5247 7.88337C14.8664 7.9167 15.1164 8.22504 15.083 8.5667C15.0414 8.88337 14.7664 9.12504 14.4497 9.12504Z" fill="#7A28A0"/>
                                    <path d="M17.5 18.958H2.5C2.15833 18.958 1.875 18.6747 1.875 18.333C1.875 17.9913 2.15833 17.708 2.5 17.708H17.5C17.8417 17.708 18.125 17.9913 18.125 18.333C18.125 18.6747 17.8417 18.958 17.5 18.958Z" fill="#7A28A0"/>
                                </svg>
                            </span>
                            <small>Step 1</small>
                        </div>
                        <div class="media-body">
                            <h3>Type or Paste Your Text</h3>
                            <p>Type or paste the text you want to paraphrase.</p>
                        </div>
                    </div>
                    <div class="useCard media media-steps middle-steps">
                        <div class="media-left">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <path d="M13.7504 11.8711H7.33376C6.95792 11.8711 6.64626 11.5594 6.64626 11.1836C6.64626 10.8078 6.95792 10.4961 7.33376 10.4961H13.7504C14.1263 10.4961 14.4379 10.8078 14.4379 11.1836C14.4379 11.5594 14.1263 11.8711 13.7504 11.8711Z" fill="#7A28A0"/>
                                    <path d="M11.3488 15.5371H7.33376C6.95792 15.5371 6.64626 15.2254 6.64626 14.8496C6.64626 14.4738 6.95792 14.1621 7.33376 14.1621H11.3488C11.7246 14.1621 12.0363 14.4738 12.0363 14.8496C12.0363 15.2254 11.7246 15.5371 11.3488 15.5371Z" fill="#7A28A0"/>
                                    <path d="M12.8338 6.18717H9.16709C8.28709 6.18717 6.64626 6.18717 6.64626 3.66634C6.64626 1.14551 8.28709 1.14551 9.16709 1.14551H12.8338C13.7138 1.14551 15.3546 1.14551 15.3546 3.66634C15.3546 4.54634 15.3546 6.18717 12.8338 6.18717ZM9.16709 2.52051C8.25959 2.52051 8.02126 2.52051 8.02126 3.66634C8.02126 4.81217 8.25959 4.81217 9.16709 4.81217H12.8338C13.9796 4.81217 13.9796 4.57384 13.9796 3.66634C13.9796 2.52051 13.7413 2.52051 12.8338 2.52051H9.16709Z" fill="#7A28A0"/>
                                    <path d="M13.75 20.8536H8.25C3.09833 20.8536 2.0625 18.4886 2.0625 14.6661V9.16608C2.0625 4.98608 3.575 3.19858 7.29667 3.00608C7.66333 2.98774 8.0025 3.27191 8.02083 3.65691C8.03917 4.04191 7.74583 4.35358 7.37 4.37191C4.76667 4.51858 3.4375 5.29774 3.4375 9.16608V14.6661C3.4375 18.0577 4.10667 19.4786 8.25 19.4786H13.75C17.8933 19.4786 18.5625 18.0577 18.5625 14.6661V9.16608C18.5625 5.29774 17.2333 4.51858 14.63 4.37191C14.2542 4.35358 13.9608 4.02358 13.9792 3.64774C13.9975 3.27191 14.3275 2.97858 14.7033 2.99691C18.425 3.19858 19.9375 4.98607 19.9375 9.15691V14.6569C19.9375 18.4886 18.9017 20.8536 13.75 20.8536Z" fill="#7A28A0"/>
                                </svg>
                            </span>
                            <small>Step 2</small>
                        </div>
                        <div class="media-body">
                            <h3>Customize & Paraphrase</h3>
                            <p>Adjust the degree of change within the rephrased alternatives</p>
                        </div>
                    </div>
                    <div class="useCard media media-steps">
                        <div class="media-left">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                    <path d="M13.9567 20.8538H7.83333C4.4875 20.8538 2.5625 18.9288 2.5625 15.583V7.79134C2.5625 4.44551 4.4875 2.52051 7.83333 2.52051H15.1667C18.5125 2.52051 20.4375 4.44551 20.4375 7.79134V12.4938C20.4375 12.7597 20.2817 12.998 20.0525 13.1172C19.8142 13.2272 19.53 13.1996 19.3283 13.0346C17.88 11.8796 15.6525 11.8797 14.2042 13.0622C13.2142 13.8413 12.655 15.0055 12.655 16.2797C12.655 17.0314 12.8567 17.7647 13.2508 18.3972C13.5533 18.8922 13.9292 19.3047 14.3692 19.6164C14.6075 19.7905 14.7175 20.1022 14.6258 20.3863C14.5158 20.6613 14.2592 20.8538 13.9567 20.8538ZM7.83333 3.89551C5.21167 3.89551 3.9375 5.16967 3.9375 7.79134V15.583C3.9375 18.2047 5.21167 19.4788 7.83333 19.4788H12.3158C12.2242 19.3597 12.1417 19.2314 12.0683 19.103C11.5458 18.2597 11.2708 17.2788 11.2708 16.2705C11.2708 14.5747 12.0225 13.0163 13.3425 11.9805C14.91 10.7063 17.2292 10.4313 19.0625 11.2747V7.79134C19.0625 5.16967 17.7883 3.89551 15.1667 3.89551H7.83333Z" fill="#7A28A0"/>
                                    <path d="M16.7715 21.7713C15.5982 21.7713 14.489 21.4046 13.554 20.7263C12.9673 20.3046 12.4631 19.7547 12.069 19.1038C11.5465 18.2605 11.2715 17.2796 11.2715 16.2713C11.2715 14.5755 12.0232 13.0171 13.3432 11.9813C15.2498 10.4321 18.2565 10.4229 20.1815 11.9538C21.5107 12.9988 22.2715 14.5755 22.2715 16.2713C22.2715 17.2796 21.9965 18.2605 21.474 19.1038C21.1807 19.608 20.8048 20.048 20.374 20.4055C19.3931 21.2855 18.1098 21.7713 16.7715 21.7713ZM16.7715 12.1463C15.8365 12.1463 14.9198 12.4671 14.1957 13.0538C13.2057 13.833 12.6465 14.9971 12.6465 16.2713C12.6465 17.023 12.8481 17.7563 13.2423 18.3888C13.5448 18.8838 13.9206 19.2963 14.3606 19.608C15.0665 20.1213 15.9007 20.3963 16.7715 20.3963C17.789 20.3963 18.724 20.0388 19.4757 19.3696C19.8057 19.0946 20.0715 18.7738 20.2915 18.398C20.6856 17.7563 20.8965 17.023 20.8965 16.2713C20.8965 14.9971 20.3282 13.8238 19.329 13.0354C18.5957 12.4488 17.7157 12.1463 16.7715 12.1463Z" fill="#7A28A0"/>
                                    <path d="M16.7702 19.2503C16.3943 19.2503 16.0827 18.9387 16.0827 18.5628C16.0827 17.6828 15.3585 16.9587 14.4785 16.9587C14.1027 16.9587 13.791 16.647 13.791 16.2712C13.791 15.8953 14.1027 15.5837 14.4785 15.5837C15.3585 15.5837 16.0827 14.8595 16.0827 13.9795C16.0827 13.6037 16.3943 13.292 16.7702 13.292C17.146 13.292 17.4577 13.6037 17.4577 13.9795C17.4577 14.8595 18.1818 15.5837 19.0618 15.5837C19.4377 15.5837 19.7493 15.8953 19.7493 16.2712C19.7493 16.647 19.4377 16.9587 19.0618 16.9587C18.1818 16.9587 17.4577 17.6828 17.4577 18.5628C17.4577 18.9387 17.146 19.2503 16.7702 19.2503ZM16.376 16.2712C16.5135 16.3903 16.651 16.5187 16.7702 16.6653C16.8893 16.5278 17.0177 16.3903 17.1643 16.2712C17.0268 16.152 16.8893 16.0237 16.7702 15.877C16.651 16.0237 16.5227 16.152 16.376 16.2712Z" fill="#7A28A0"/>
                                    <path d="M6.1476 8.60159L7.55267 10.0722L10.5001 7.47511" stroke="#7A28A0" stroke-width="0.9"/>
                                    <path d="M6.1476 13.6016L7.55267 15.0722L10.5001 12.4751" stroke="#7A28A0" stroke-width="0.9"/>
                                </svg>
                            </span>
                            <small>Step 3</small>
                        </div>
                        <div class="media-body">
                            <h3>Check Revisions & Copy</h3>
                            <p>Review the paraphrased text, make edits as needed, and copy the final version.</p>
                        </div>
                    </div>
                </div>
                <div class="btn-group mt-3">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" class="filled-btn" target="_blank" rel="noopener noreferrer">Try Paraphrasing Now!</a>
                </div> 
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-image pr-4">
                    <img src="assets/images/paraphraser/online_paraphrase_banner.svg" alt="ai detector" class="img-fluid w-100" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center align-items-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h2>What are the Features of Paraphrasing Tool?</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2 pr-80" style="padding: 0;">
                        <ul class="list-box">
                            <li>With multiple options at your disposal, achieving clearer content is now easy.</li>
                            <li>Adjust the degree of variation to suit your needs and refine your content in seconds.</li>
                            <li>Say goodbye to grammar errors as our AI paraphraser and <a [routerLink]="['/grammar-checker']" class="text-link">grammar checker</a> automatically corrects them for polished and error-free writing.</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="../../../assets/images/academic-parapharsing.svg" alt="paraphrasing tool"  class="img-fluid" />
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h2 class="text-white">Trinka’s paraphrasing tool – Smart rewrites, every time! </h2>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" class="white-btn" target="_blank" rel="noopener noreferrer">Try Now</a>
                </div>
            </div>
        </div>  
    </div>
</div>


<div class="cloud_key_features section-pd bg-light-purple list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>What are the Benefits of Trinka’s Paraphrasing Tool?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Explore the full range of features that Trinka’s Online Paraphrasing Tool offers.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="../../../assets/images/paraphrasing-icons/Efficiency.png" width="50" height="50" alt="Paraphrase Efficiency" style="min-width: 50px;">
                    <h3>Paraphrase Efficiently</h3>
                    <p>Trinka’s paraphrasing tool helps to reduce time and effort required   manually restructure content, enabling you to focus on your work, rather than the language used.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/paraphrasing-icons/Accuracy.png" width="40" height="50" alt="Improved Clarity" style="max-width: auto;">
                    <h3>Improve<br class="d-lg-block d-none"/> Clarity</h3>
                    <p>Trinka ensures that the reworded versions maintain the original meaning and integrity of the text,  leaving no room for any misinterpretations.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/paraphrasing-icons/Vocabulary.png" width="40" height="50" alt="Remove Grammar Errors" style="max-width: auto;">
                    <h3>Remove Grammar Errors</h3>
                    <p>Trinka instantly helps remove grammar mistakes, ensuring precise and flawless written communication.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <section class="section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="pricing-section">
                    <div class="pricing-wrapper">
                  
                      <div class="pricing-card free-card">
                        <div class="card-header">
                          <h2>Free</h2>
                        </div>
                  
                        <div class="card-body">
                            <ul class="bt-list">
                                <li>Standard</li>
                            </ul>
                        </div>
                  
                      </div>
                  
                      <div class="pricing-card premium-card">
                        <div class="card-header premium-header">
                          <h2 class="text-white">Premium</h2>
                          <span class="badge">Popular</span>
                        </div>
                  
                        <div class="card-body">
                          <ul class="bt-list">
                            <li>Academic</li>
                            <li>Formal</li>
                            <li>Concise</li>
                            <li>Simple</li>
                          </ul>
                        </div>
                  
                        <div class="card-footer btn-group">
                          <a href="https://cloud.trinka.ai/signup?_rg=GB" class="white-btn w-100" target="_blank" rel="noopener noreferrer">Upgrade to Premium</a>

                        </div>
                      </div>
                  
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10">
                <div class="trinka-title text-center">
                    <h2 class="text-white">Get an all-round improvement in your writing with Trinka's Grammar Checker</h2>
                </div>
                <div class="btn-group justify-content-center">
                    <a [routerLink]="['/grammar-checker']" class="white-btn">Try Grammar Checker Now!</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="suitableForSection section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-9">
                <div class="trinka-title text-center">
                    <h2>Who Can Benefit from Trinka's Paraphrasing Tool?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Trinka is perfect for anyone wanting to enhance their English writing skills. Along with the paraphrasing tool, our free <a [routerLink]="['/grammar-checker']" class="text-link">grammar checker</a> is also a trusted tool by academics, copywriters, marketers, product teams, bloggers, and more.</p>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M28.05 26.0667C29.1667 25.3333 30.6333 26.1333 30.6333 27.4667V29.6167C30.6333 31.7333 28.9833 34 27 34.6667L21.6833 36.4333C20.75 36.75 19.2333 36.75 18.3167 36.4333L13 34.6667C11 34 9.36667 31.7333 9.36667 29.6167V27.45C9.36667 26.1333 10.8333 25.3333 11.9333 26.05L15.3667 28.2833C16.6833 29.1667 18.35 29.6 20.0167 29.6C21.6833 29.6 23.35 29.1667 24.6667 28.2833L28.05 26.0667Z" fill="#763393"/>
                            <path d="M33.3 10.7667L23.3167 4.21672C21.5167 3.03339 18.55 3.03339 16.75 4.21672L6.71667 10.7667C3.5 12.8501 3.5 17.5667 6.71667 19.6667L9.38334 21.4001L16.75 26.2001C18.55 27.3834 21.5167 27.3834 23.3167 26.2001L30.6333 21.4001L32.9167 19.9001V25.0001C32.9167 25.6834 33.4833 26.2501 34.1667 26.2501C34.85 26.2501 35.4167 25.6834 35.4167 25.0001V16.8001C36.0833 14.6501 35.4 12.1501 33.3 10.7667Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h3>Students</h3>
                        <p>Our paraphrasing tool helps you rewrite your assignments, essays, papers and homework with improved clarity and better sentence structure.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <path d="M15 3.33331C10.6333 3.33331 7.08333 6.88331 7.08333 11.25C7.08333 15.5333 10.4333 19 14.8 19.15C14.9333 19.1333 15.0667 19.1333 15.1667 19.15C15.2 19.15 15.2167 19.15 15.25 19.15C15.2667 19.15 15.2667 19.15 15.2833 19.15C19.55 19 22.9 15.5333 22.9167 11.25C22.9167 6.88331 19.3667 3.33331 15 3.33331Z" fill="#763393"/>
                            <path d="M23.4667 23.5833C18.8167 20.4833 11.2333 20.4833 6.55 23.5833C4.43333 25 3.26666 26.9166 3.26666 28.9666C3.26666 31.0166 4.43333 32.9166 6.53333 34.3166C8.86666 35.8833 11.9333 36.6666 15 36.6666C18.0667 36.6666 21.1333 35.8833 23.4667 34.3166C25.5667 32.9 26.7333 31 26.7333 28.9333C26.7167 26.8833 25.5667 24.9833 23.4667 23.5833Z" fill="#763393"/>
                            <path d="M33.3167 12.2334C33.5833 15.4667 31.2833 18.3 28.1 18.6834C28.0833 18.6834 28.0833 18.6834 28.0667 18.6834H28.0167C27.9167 18.6834 27.8167 18.6834 27.7333 18.7167C26.1167 18.8 24.6333 18.2834 23.5167 17.3334C25.2333 15.8 26.2167 13.5 26.0167 11C25.9 9.65002 25.4333 8.41669 24.7333 7.36669C25.3667 7.05002 26.1 6.85002 26.85 6.78336C30.1167 6.50002 33.0333 8.93336 33.3167 12.2334Z" fill="#763393"/>
                            <path d="M36.65 27.65C36.5167 29.2667 35.4833 30.6667 33.75 31.6167C32.0833 32.5334 29.9833 32.9667 27.9 32.9167C29.1 31.8334 29.8 30.4834 29.9333 29.05C30.1 26.9834 29.1167 25 27.15 23.4167C26.0333 22.5334 24.7333 21.8334 23.3167 21.3167C27 20.25 31.6333 20.9667 34.4833 23.2667C36.0167 24.5 36.8 26.05 36.65 27.65Z" fill="#763393"/>
                        </svg>
                    </div>
                    <div class="media-body">
                        <h3>For Professionals</h3>
                        <p>You can rephrase and refine the content of your research papers, thesis, documents, journals and more, while preserving the precision and formal tone. </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg fill="#763393" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="40px" viewBox="0 0 897.5 897.5" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M30.48,50v797.5c0,27.6,22.4,50,50,50h140.7c27.6,0,50-22.4,50-50V50c0-27.6-22.4-50-50-50H80.48 C52.88,0,30.48,22.4,30.48,50z M226.98,798.399c0,11-9,20-20,20H94.68c-11,0-20-9-20-20v-3.8c0-11,9-20,20-20h112.3 c11,0,20,9,20,20V798.399z M226.98,230c0,11-9,20-20,20H94.68c-11,0-20-9-20-20v-3.8c0-11,9-20,20-20h112.3c11,0,20,9,20,20V230z M94.68,90.3h112.3c11,0,20,9,20,20v3.8c0,11-9,20-20,20H94.68c-11,0-20-9-20-20v-3.8C74.68,99.3,83.68,90.3,94.68,90.3z"></path> <path d="M556.88,34.4c-10.601-25.5-39.9-37.6-65.4-27l-129.9,54c-25.5,10.6-37.6,39.9-27,65.4L640.88,863.1 c10.6,25.5,39.899,37.601,65.399,27l129.9-54c25.5-10.6,37.6-39.899,27-65.399L556.88,34.4z M400.08,169.1l-1.5-3.5 c-4.199-10.2,0.601-21.9,10.801-26.1l103.8-43.2c10.2-4.2,21.899,0.6,26.1,10.8l1.5,3.5c4.2,10.2-0.6,21.9-10.8,26.1l-103.7,43.1 C416.08,184.1,404.38,179.3,400.08,169.1z M574.48,243.7l-103.7,43.1c-10.2,4.2-21.899-0.6-26.1-10.8l-1.5-3.5 c-4.2-10.2,0.6-21.9,10.8-26.1l103.7-43.1c10.2-4.2,21.899,0.6,26.1,10.8l1.5,3.5C589.48,227.7,584.68,239.4,574.48,243.7z M792.78,768.399L689.08,811.5c-10.199,4.2-21.899-0.601-26.1-10.8l-1.5-3.5c-4.2-10.2,0.6-21.9,10.8-26.101l103.7-43.1 c10.2-4.2,21.9,0.6,26.1,10.8l1.5,3.5C807.78,752.5,802.98,764.2,792.78,768.399z"></path> </g> </g> </g></svg>
                    </div>
                    <div class="media-body">
                        <h3>For Researchers & Academics</h3>
                        <p>You can rephrase and refine the content of your research papers, thesis, documents, journals and more, while preserving the precision and formal tone.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <path d="M35.5 36.6666H5.5C4.81667 36.6666 4.25 36.1 4.25 35.4166C4.25 34.7333 4.81667 34.1666 5.5 34.1666H35.5C36.1833 34.1666 36.75 34.7333 36.75 35.4166C36.75 36.1 36.1833 36.6666 35.5 36.6666Z" fill="#763393"/>
                            <path d="M32.2 5.79998C28.9667 2.56664 25.8 2.48331 22.4833 5.79998L20.4667 7.81664C20.3 7.98331 20.2333 8.24998 20.3 8.48331C21.5667 12.9 25.1 16.4333 29.5167 17.7C29.5833 17.7166 29.65 17.7333 29.7167 17.7333C29.9 17.7333 30.0667 17.6666 30.2 17.5333L32.2 15.5166C33.85 13.8833 34.65 12.3 34.65 10.7C34.6667 9.04998 33.8667 7.44998 32.2 5.79998Z" fill="#763393"/>
                            <path d="M26.5167 19.2167C26.0333 18.9834 25.5667 18.75 25.1167 18.4834C24.75 18.2667 24.4 18.0334 24.05 17.7834C23.7667 17.6 23.4333 17.3334 23.1167 17.0667C23.0833 17.05 22.9667 16.95 22.8333 16.8167C22.2833 16.35 21.6667 15.75 21.1167 15.0834C21.0667 15.05 20.9833 14.9334 20.8667 14.7834C20.7 14.5834 20.4167 14.25 20.1667 13.8667C19.9667 13.6167 19.7333 13.25 19.5167 12.8834C19.25 12.4334 19.0167 11.9834 18.7833 11.5167C18.6716 11.2773 18.5713 11.0417 18.4789 10.8117C18.3429 10.4735 17.9062 10.3771 17.6485 10.6349L7.73333 20.55C7.51666 20.7667 7.31666 21.1834 7.26666 21.4667L6.36666 27.85C6.19999 28.9834 6.51666 30.05 7.21666 30.7667C7.81666 31.35 8.64999 31.6667 9.54999 31.6667C9.74999 31.6667 9.94999 31.65 10.15 31.6167L16.55 30.7167C16.85 30.6667 17.2667 30.4667 17.4667 30.25L27.3746 20.3421C27.6342 20.0825 27.5355 19.6393 27.1952 19.5017C26.9754 19.4129 26.7516 19.3185 26.5167 19.2167Z" fill="#763393"/>
                        </svg>                    </div>
                    <div class="media-body">
                        <h3>For Content Writers & Marketers</h3>
                        <p>Create unique versions of blogs, articles, website copy, and marketing content for your brands faster.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-8">
                <div class="trinka-title mb-0 text-center">
                    <h2>Why Writers Prefer Our Paraphrasing Tool?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Our free AI paraphrasing tool provides a convenient and easy way for students, professionals, and writers to paraphrase text while preserving its original meaning. </p>
                </div>
            </div>
            <div class="col-lg-10">
                <table class="compare-table">
                    <thead>
                        <tr>
                            <th>Benefits</th>
                            <th>AI Paraphrasing Tool</th>
                            <th>Other Paraphrasing Tool</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Free to Use</td>
                            <td><img src="assets/images/tick-circle.svg" alt="check"></td>
                            <td><img src="assets/images/close-circle.svg" alt="close"></td>
                        </tr>
                        <tr>
                            <td>Grammar Checks up to 500 words</td>
                            <td><img src="assets/images/tick-circle.svg" alt="check"></td>
                            <td><img src="assets/images/close-circle.svg" alt="close"></td>
                        </tr>
                        <tr>
                            <td>Easy & Quick to Use</td>
                            <td><img src="assets/images/tick-circle.svg" alt="check"></td>
                            <td><img src="assets/images/close-circle.svg" alt="close"></td>
                        </tr>
                        <tr>
                            <td>No Sign Up</td>
                            <td><img src="assets/images/tick-circle.svg" alt="check"></td>
                            <td><img src="assets/images/close-circle.svg" alt="close"></td>
                        </tr>
                        <tr>
                            <td>Check Revisions </td>
                            <td><img src="assets/images/tick-circle.svg" alt="check"></td>
                            <td><img src="assets/images/close-circle.svg" alt="close"></td>
                        </tr>
                        <tr>
                            <td>Sentence Level Rephrase</td>
                            <td><img src="assets/images/tick-circle.svg" alt="check"></td>
                            <td><img src="assets/images/close-circle.svg" alt="close"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pb-0">
    <app-tool-kit [hiddenTools]="['spell-checker']"></app-tool-kit>
</section>


<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinka’s Paraphrasing Tool FAQ</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCOneContent" aria-expanded="true"
                                        aria-controls="QuestionGCOneContent">
                                        What is Trinka's Paraphrasing Tool?</a>
                                </div>

                                <div id="QuestionGCOneContent" class="collapse"
                                    aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphraser is a free online paraphrasing tool that helps to generate high-quality paraphrases and sentence changes while preserving the original meaning of the text.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwoContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwoContent">How to use Trinka's Paraphrasing tool?</a>
                                </div>

                                <div id="QuestionGCTwoContent" class="collapse"
                                    aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>For first-time users, here are the steps to use Trinka Paraphrasing tool:</p>
                                        <ul>
                                            <li><b>Access Trinka Paraphraser</b></li>
                                            <li><b>Input your content:</b> Copy and paste the text you want to paraphrase into the provided box.</li>
                                            <li><b>Start paraphrasing:</b> Click on the paraphrase button to begin the process.</li>
                                            <li><b>Review the results: </b> Trinka Paraphraser will generate the paraphrased version of your content. Read through it to see if it meets your requirements.</li>
                                            <li><b>Make adjustments (if needed):</b> If necessary, you can make manual adjustments to the paraphrased text to further tailor it to your liking.</li>
                                            <li><b>Finalize and use:</b> Once you are satisfied with the paraphrased content, use it in your writing or any other desired application.</li>
                                        </ul>
                                        <p>By following these steps, you can easily and effectively use Trinka Paraphrasing tool to paraphrase your content.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThreeContent" aria-expanded="true"
                                        aria-controls="QuestionGCThreeContent">How does Trinka Paraphrasing tool work?</a>
                                </div>

                                <div id="QuestionGCThreeContent" class="collapse"
                                    aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka Paraphrasing tool uses sophisticated algorithms to analyse and rephrase text, providing users with alternative versions that maintain coherence and readability.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFourContent" aria-expanded="true"
                                        aria-controls="QuestionGCFourContent">Is Trinka's Paraphrasing Tool accessible online or requires installation?</a>
                                </div>

                                <div id="QuestionGCFourContent" class="collapse"
                                    aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Our online paraphrasing tool, making it easily accessible without the need for installation.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFiveContent" aria-expanded="true"
                                        aria-controls="QuestionGCFiveContent">What makes Trinka's Paraphraser stand out from other paraphrasing tools like quillbot paraphraser?</a>
                                </div>

                                <div id="QuestionGCFiveContent" class="collapse"
                                    aria-labelledby="QuestionGCFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphrasing tool offers real-time paraphrasing capabilities, a choice for the degree of change, multiple paraphrased options, and automatic grammar error correction by utilizing sentence rephraser unlike other paraphrasing tools available in the market.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSixContent" aria-expanded="true"
                                        aria-controls="QuestionGCSixContent">Who can use Trinka's Paraphraser?</a>
                                </div>

                                <div id="QuestionGCSixContent" class="collapse"
                                    aria-labelledby="QuestionGCSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>The Trinka Paraphraser is designed to cater to a wide range of users, including academicians from various disciplines such as science and technology, content writers, bloggers, students, researchers, and professionals seeking to generate unique content variations.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSevenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSevenContent">Is there a word limit for paraphrasing with Trinka's Paraphraser?</a>
                                </div>

                                <div id="QuestionGCSevenContent" class="collapse"
                                    aria-labelledby="QuestionGCSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Currently, Trinka Paraphrasing tool allows you to paraphrase up to 500 words at a time, but you can use it as much as you want without any restrictions. Unlike other online paraphrasing tools that might have word limits, Trinka Paraphraser offers unlimited usage for its users.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCEightContent" aria-expanded="true"
                                        aria-controls="QuestionGCEightContent">Is Trinka's Rephraser suitable for academic writers?</a>
                                </div>

                                <div id="QuestionGCEightContent" class="collapse"
                                    aria-labelledby="QuestionGCEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes, Trinka Rephraser or paraphrasing tool is specifically developed to provide valuable support to academic writers with their research papers and articles.  It assists them in rephrasing their content effectively, creating original and unique variations, all while maintaining the same meaning.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCNineContent" aria-expanded="true"
                                        aria-controls="QuestionGCNineContent">Can bloggers use the free AI Paraphrasing tool to improve their content?</a>
                                </div>

                                <div id="QuestionGCNineContent" class="collapse"
                                    aria-labelledby="QuestionGCNine" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Absolutely, bloggers can use our free AI paraphrasing tool online to rewrite articles, explore alternative ways to express their ideas, and enhance the quality of their posts.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTenContent" aria-expanded="true"
                                        aria-controls="QuestionGCTenContent">How does Trinka's online AI Paraphrasing tool address the issue of time-consuming paraphrasing?</a>
                                </div>

                                <div id="QuestionGCTenContent" class="collapse"
                                    aria-labelledby="QuestionGCTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's paraphrasing tool, gives real-time paraphrasing feature helps users save time by generating alternative versions as they write.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCeleven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCelevenContent" aria-expanded="true"
                                        aria-controls="QuestionGCelevenContent">How does Trinka's Paraphraser enhance efficiency in writing tasks?</a>
                                </div>

                                <div id="QuestionGCelevenContent" class="collapse"
                                    aria-labelledby="QuestionGCeleven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphraser boosts writing efficiency by assisting users who experience writer's block or have limited vocabulary. It helps writers find the right words to express their ideas perfectly and communicate effectively.</p>
                                    </div>
                                </div>
                            </div>


                            <div class="card">
                                <div class="card-header" id="QuestionGCTwelve">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwelveContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwelveContent">Can users customize the level of variation required in the paraphrased text with Trinka's free Paraphrasing tool?</a>
                                </div>

                                <div id="QuestionGCTwelveContent" class="collapse"
                                    aria-labelledby="QuestionGCTwelve" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes, users can tailor the degree of change in the paraphrased content based on their requirements with our paraphrasing tool.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCThirteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThirteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCThirteenContent">How does Trinka's Paraphrasing Tool rectify grammar errors in paraphrased text? </a>
                                </div>

                                <div id="QuestionGCThirteenContent" class="collapse"
                                    aria-labelledby="QuestionGCThirteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphrasing Tool automatically corrects grammar errors with its built-in free <a [routerLink]="['/grammar-checker']" target="_blank" class="text-link">grammar checker</a> engine. Ensuring that your paraphrased content is polished and free from writing mistakes.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFouteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFouteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCFouteenContent">How does Trinka's Paraphraser promote originality in academic work? </a>
                                </div>

                                <div id="QuestionGCFouteenContent" class="collapse"
                                    aria-labelledby="QuestionGCFouteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>With its innovative paraphrasing techniques, Trinka Paraphraser fosters creativity, leading to fresh and original paraphrased content.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFivteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFivteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCFivteenContent">Can Trinka's Paraphrasing Tool maintain consistency in paraphrased content?</a>
                                </div>

                                <div id="QuestionGCFivteenContent" class="collapse"
                                    aria-labelledby="QuestionGCFivteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes, our best paraphrasing tool ensures consistency and coherence throughout the paraphrased content, enhancing readability.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSixteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSixteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSixteenContent">How does Trinka's free Paraphrasing Tool help users avoid unintentional plagiarism?</a>
                                </div>

                                <div id="QuestionGCSixteenContent" class="collapse"
                                    aria-labelledby="QuestionGCSixteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>The advanced algorithms of Trinka's Paraphrasing tool make sure to paraphrase responsibly, checking and safeguarding against unintentional plagiarism. This ensures that your content remains original and avoids any accidental copying.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeventeen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSeventeenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSeventeenContent">Does Trinka's Paraphrasing Tool offer browser extensions or add-ons for quick access?</a>
                                </div>

                                <div id="QuestionGCSeventeenContent" class="collapse"
                                    aria-labelledby="QuestionGCSeventeen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphrasing Tool will be available on browser extension soon for convenient access during writing tasks.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEighteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCEighteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCEighteenContent">Will Trinka's Paraphraser be available on Word Add-in for quick access? </a>
                                </div>

                                <div id="QuestionGCEighteenContent" class="collapse"
                                    aria-labelledby="QuestionGCEighteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphraser will soon be available as a Word Add-in, making it easy to access while writing in your familiar and comfortable writing environment.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNinteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCNinteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCNinteenContent">Can Trinka's Paraphrasing Tool be integrated with other writing tools or platforms?</a>
                                </div>

                                <div id="QuestionGCNinteenContent" class="collapse"
                                    aria-labelledby="QuestionGCNinteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphrasing tool may offer integration options with popular writing tools or platforms soon, to enhance user convenience. Meanwhile try our other free writing tools to help improve your overall content quality and AI checks: <a [routerLink]="['/grammar-checker']" target="_blank" class="text-link">
                                            Grammar Checker
                                          </a>
                                        , 
                                          <a [routerLink]="['/ai-content-detector']" class="text-link">
                                            AI Detector
                                          </a>
                                        , 
                                          <a [routerLink]="['/journal-finder']" class="text-link">
                                            Journal Finder
                                          </a>
                                        , 
                                          <a [routerLink]="['/thesis-checker']" class="text-link">
                                            Thesis Checker
                                          </a>
                                        ,   
                                          <a [routerLink]="['/punctuation-checker']" class="text-link">
                                            Punctuation Checker
                                          </a> and more </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC20">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC20Content" aria-expanded="true"
                                        aria-controls="QuestionGC20Content">Is customer support available for users experiencing issues with Trinka's Paraphraser?</a>
                                </div>

                                <div id="QuestionGC20Content" class="collapse"
                                    aria-labelledby="QuestionGC20" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes, Trinka has a dedicated customer support team to assist users with any problems they may encounter at any point of time. Please reach out to <a href="mailto:support&#64;trinka&#46;ai">Trinka Support</a> </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC21">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC21Content" aria-expanded="true"
                                        aria-controls="QuestionGC21Content">How does Trinka's Paraphrasing Tool handle user data and content? </a>
                                </div>

                                <div id="QuestionGC21Content" class="collapse"
                                    aria-labelledby="QuestionGC21" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphrasing Tool follows strict data privacy measures and ensures the security of user data and content, and makes sures no data is stored </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC22">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC22Content" aria-expanded="true"
                                        aria-controls="QuestionGC22Content">Does Trinka's Paraphraser receive regular updates and improvements?</a>
                                </div>

                                <div id="QuestionGC22Content" class="collapse"
                                    aria-labelledby="QuestionGC22" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka's Paraphraser is always getting better, and our team is continuously working on updates and enhancements to improve its performance and user experience. We are committed to making it even more effective and user-friendly for our users.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC23">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC23Content" aria-expanded="true"
                                        aria-controls="QuestionGC23Content">Are user feedback and suggestions considered for the improvement of Trinka's Paraphrasing Tool?</a>
                                </div>

                                <div id="QuestionGC23Content" class="collapse"
                                    aria-labelledby="QuestionGC23" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Absolutely! At Trinka, we highly value user feedback and suggestions. They play a crucial role in refining and enhancing Trinka Paraphraser's features. We welcome input from our users as it helps us make the tool even better and more useful for everyone.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC24">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC24Content" aria-expanded="true"
                                        aria-controls="QuestionGC24Content">Does a paraphrasing tool fix grammar mistakes?</a>
                                </div>

                                <div id="QuestionGC24Content" class="collapse"
                                    aria-labelledby="QuestionGC24" data-parent="#faq">
                                    <div class="card-body">
                                        <p>While paraphrasing improves sentence structure and clarity, it may not correct all grammatical errors. For complete accuracy, use a dedicated <a [routerLink]="['/grammar-checker']" class="text-link">Grammar Checker</a> to detect punctuation, spelling, and syntax issues.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>